import { cn } from "@/lib/cn";
import { useFrameSurface } from "./use-frame-surface";

/** What a lazy frame type shows while its chunk loads: the memory frame's
 *  skeleton, an empty box for every other type. */
export function FrameLazyFallback({
  frameId,
  frameType,
  selected,
}: {
  frameId: string;
  frameType: string;
  selected: boolean;
}) {
  const frameSurface = useFrameSurface(frameId);
  if (frameType !== "memory") {
    return (
      <div
        className="h-full w-full"
        data-testid={`frame-lazy-fallback-${frameType}`}
      />
    );
  }

  return (
    <div
      className={cn(
        frameSurface.className,
        "flex h-full flex-col overflow-hidden",
        selected
          ? "border-[var(--frame-selected-stroke)]"
          : "border-glass-stroke",
      )}
      data-testid="memory-frame-loading"
      {...frameSurface.attributes}
    >
      <div
        className="flex min-h-[var(--denk-frame-header-min-height)] shrink-0 items-center border-b border-glass-stroke-faint px-3"
        data-frame-header="true"
      >
        <div
          className="h-2.5 w-28 rounded-control-sm bg-glass-fill-dense"
          data-testid="memory-frame-loading-header"
        />
      </div>
      <div className="min-h-0 flex-1 p-2" data-frame-content="true">
        <div
          className="h-full w-full rounded-control border border-glass-stroke-faint bg-glass-fill-faint"
          data-testid="memory-frame-loading-content"
        />
      </div>
      <div
        className="min-h-[var(--denk-frame-footer-min-height)] shrink-0 border-t border-glass-stroke-faint"
        data-frame-footer="true"
        data-testid="memory-frame-loading-footer"
      />
    </div>
  );
}
